import React from 'react';
import { hoursOptions } from '../../../lib/constants';
import { apiUpdateActivitiesList } from '../../../lib/apiPaseLista'; 
import styles from './cards.module.css';

const CardActivities = props => {
    const { actividades, id, NotificationManager, editable, is_destajo, taxi, id_estatus, onReload } = props;

    const [activitiesList, setActivitiesList] = React.useState([]);
    const [isEditing, setIsEditing] = React.useState(false);

    React.useEffect(() => {
        // Hacemos una copia profunda para poder manipular los cultivos sin afectar el estado original hasta guardar
        setActivitiesList(JSON.parse(JSON.stringify(actividades)));
    }, [actividades]);

    const changeIsEditing = () => {
        if (isEditing) {
            setActivitiesList(JSON.parse(JSON.stringify(actividades))); // Restaura si cancela
        }
        setIsEditing(!isEditing);
    };

    // 🟢 Función para editar horas, con soporte para sub-cultivos
    const setExtraHours = (e, id_actividad, id_cultivo = null) => {
        const nuevoValor = e.target.value;

        setActivitiesList(prevList => prevList.map(act => {
            if (act.id_actividad === id_actividad) {
                
                // Si la edición viene de un cultivo específico
                if (id_cultivo !== null && act.cultivos && act.cultivos.length > 0) {
                    const nuevosCultivos = act.cultivos.map(c => 
                        c.id_cultivo === id_cultivo ? { ...c, horas_extra: nuevoValor } : c
                    );
                    
                    // Sumamos las nuevas horas extra de los cultivos para actualizar el total de la actividad
                    const totalExtra = nuevosCultivos.reduce((acc, current) => acc + parseFloat(current.horas_extra || 0), 0);
                    
                    return { ...act, cultivos: nuevosCultivos, horas_extra: totalExtra };
                } 
                // Si la actividad no tiene cultivos, se edita directo en la actividad
                else {
                    return { ...act, horas_extra: nuevoValor };
                }
            }
            return act;
        }));
    };

    const saveActivities = () => {
        // El payload ahora incluye los cultivos desglosados para que el backend pueda guardarlos
        apiUpdateActivitiesList(id, {
            actividades: activitiesList.map(elm => ({
                id: elm.id_actividad,
                horas_extra: elm.horas_extra,
                numero_horas: elm.numero_horas,
                cultivos: elm.cultivos ? elm.cultivos.map(c => ({
                    id_cultivo: c.id_cultivo,
                    horas_extra: c.horas_extra,
                    numero_horas: c.numero_horas
                })) : []
            })),
        })
            .then(response => {
                if (response.error) {
                    NotificationManager.error(response.message, '', 5000);
                } else {
                    NotificationManager.success('Horas extra guardadas con éxito.', '', 5000);
                    setIsEditing(false);
                    if (onReload) onReload();
                }
            })
            .catch(() => NotificationManager.error('Ocurrió un error. Inténtelo más tarde', '', 5000));
    };

    return (
        <div className="card separate mb-4">
            <div className="card-body">
                <div className="row no-row-margin align-items-center mb-3">
                    <div className="col-md-6 col-12">
                        <h5 className="mb-0"><i className="fas fa-tasks mr-2" />Actividades</h5>
                    </div>

                    <div className="col-md-6 col-12 text-right">
                        {editable && id_estatus === 11 && (
                            !isEditing ? (
                                <button className="btn btn-sm btn-success" onClick={changeIsEditing}>
                                    <i className="fas fa-edit mr-2" /> Editar horas extra
                                </button>
                            ) : (
                                <React.Fragment>
                                    <button className="btn btn-sm btn-danger mr-2" onClick={changeIsEditing}>
                                        <i className="fas fa-times mr-2" /> Cancelar
                                    </button>
                                    <button className="btn btn-sm btn-success" onClick={saveActivities}>
                                        <i className="fas fa-save mr-2" /> Guardar
                                    </button>
                                </React.Fragment>
                            )
                        )}
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead>
                            <tr>
                                <th>Número</th>
                                <th>Nombre</th>
                                <React.Fragment>
                                    {taxi !== '' && <th>Jornales</th>}
                                    {!is_destajo && (
                                        <React.Fragment>
                                            <th>Horas laborales</th>
                                            <th>Horas extra</th>
                                        </React.Fragment>
                                    )}
                                    {taxi !== '' && is_destajo && <th>Destajo</th>}
                                </React.Fragment>
                            </tr>
                        </thead>
                        <tbody>
                            {activitiesList.length > 0 ? (
                                activitiesList.map(activity => (
                                    <React.Fragment key={`act-${activity.id_actividad}`}>
                                        {/* 🟢 FILA PRINCIPAL DE LA ACTIVIDAD (En negritas y sombreada) */}
                                        <tr className="bg-light font-weight-bold">
                                            <td>{activity.id_actividad}</td>
                                            <td>{activity.nombre_actividad}</td>
                                                <React.Fragment>
                                                    {taxi !== '' && <td>{activity.jornaleros}</td>}
                                                    
                                                    {/* Total Horas Laborales (Solo lectura) */}
                                                    {!is_destajo && (
                                                        <React.Fragment>
                                                            <td>
                                                                {!activity.numero_horas || parseFloat(activity.numero_horas) === 0 
                                                                    ? '0:00' 
                                                                    : hoursOptions.find(o => o.value === parseFloat(activity.numero_horas))?.hour || '0:00'}
                                                            </td>
                                                            
                                                            {/* Total Horas Extra */}
                                                            <td>
                                                                {isEditing && (!activity.cultivos || activity.cultivos.length === 0) ? (
                                                                    // Si NO tiene cultivos, dejamos editar aquí
                                                                    <select className="form-control form-control-sm" value={parseFloat(activity.horas_extra || 0)} onChange={e => setExtraHours(e, activity.id_actividad)}>
                                                                        {hoursOptions.map(hour => (
                                                                            <option key={hour.value} value={hour.value}>{hour.hour}</option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    // Si SÍ tiene cultivos, mostramos el total acumulado de solo lectura
                                                                    !activity.horas_extra || parseFloat(activity.horas_extra) === 0 
                                                                        ? '0:00' 
                                                                        : hoursOptions.find(o => o.value === parseFloat(activity.horas_extra))?.hour || activity.horas_extra
                                                                )}
                                                            </td>
                                                        </React.Fragment>
                                                    )}
                                                    
                                                    {taxi !== '' && is_destajo && <td>{activity.destajo}</td>}
                                                </React.Fragment>
                                        </tr>

                                        {/* 🟢 FILAS SECUNDARIAS DE LOS CULTIVOS */}
                                        {activity.cultivos && activity.cultivos.length > 0 && activity.cultivos.map(cultivo => (
                                            <tr key={`cult-${cultivo.id_cultivo}`}>
                                                <td></td> {/* Celda vacía para dar efecto de indentación */}
                                                <td>
                                                  <b>Cultivo: </b>{cultivo.nombre_cultivo || cultivo.nombre}
                                                </td>
                                                    {taxi !== '' && <td></td>}
                                                    
                                                    
                                                    {!is_destajo && (
                                                        <React.Fragment>
                                                            {/* Horas laborales del cultivo (Lectura) */}
                                                            <td>
                                                                {!cultivo.numero_horas || parseFloat(cultivo.numero_horas) === 0 
                                                                    ? '0:00' 
                                                                    : hoursOptions.find(o => o.value === parseFloat(cultivo.numero_horas))?.hour || '0:00'}
                                                            </td>
                                                            
                                                            {/* Horas extra del cultivo (EDITABLE) */}
                                                            <td>
                                                                {isEditing ? (
                                                                    <select className="form-control form-control-sm" value={parseFloat(cultivo.horas_extra || 0)} onChange={e => setExtraHours(e, activity.id_actividad, cultivo.id_cultivo)}>
                                                                        {hoursOptions.map(hour => (
                                                                            <option key={hour.value} value={hour.value}>{hour.hour}</option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    !cultivo.horas_extra || parseFloat(cultivo.horas_extra) === 0 
                                                                        ? '0:00' 
                                                                        : hoursOptions.find(o => o.value === parseFloat(cultivo.horas_extra))?.hour || '0:00'
                                                                )}
                                                            </td>
                                                        </React.Fragment>
                                                    )}

                                                    {taxi !== '' && is_destajo && <td></td>}
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={is_destajo ? 2 : (taxi !== '' ? 6 : 4)} className="text-center py-4 text-muted">
                                        No hay actividades registradas.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

CardActivities.defaultProps = { actividades: [] };
export default CardActivities;